import React, { useState } from "react";
import styled from "styled-components";
import { BGCOLOR, COLOR1, TEXT_TITLE_COLOR, WHITE } from "../global";
import { HiMenu } from "react-icons/hi";

export const Navbar = () => {
  const [activeNav, setActiveNav] = useState("#");
  // const [ham, setHam] = useState(false);
  const [extendNavbar, setExtendNavbar] = useState(false);

  return (
    <NavbarContainer extendNavbar={extendNavbar}>
      <NavbarInnerContainer>
        <LeftContainer>
          <NavbarLinkContainer>
            <NavbarLink
              href="#"
              onClick={() => setActiveNav("#")}
              className={activeNav === "#" ? "active" : ""}
            >
              {" "}
              Home
            </NavbarLink>
            <NavbarLink
              href="#gitStats"
              onClick={() => setActiveNav("#gitStats")}
              className={activeNav === "#gitStats" ? "active" : ""}
            >
              {" "}
              Github
            </NavbarLink>
            <NavbarLink
              href="#skills"
              onClick={() => setActiveNav("#skills")}
              className={activeNav === "#skills" ? "active" : ""}
            >
              {" "}
              Skills
            </NavbarLink>
            <NavbarLink
              href="#portfolio"
              onClick={() => setActiveNav("#portfolio")}
              className={activeNav === "#portfolio" ? "active" : ""}
            >
              {" "}
              Projects
            </NavbarLink>
            <NavbarLink
              href="#contact"
              onClick={() => setActiveNav("#contact")}
              className={activeNav === "#contact" ? "active" : ""}
            >
              {" "}
              Contact
            </NavbarLink>
            <NavbarLink
              href="https://drive.google.com/file/d/1gpJtTEZt4-CaMFKaZsSBAK0FyALSXiyT/view?usp=share_link"
              target="_blank"
            >
              {" "}
              Resume
            </NavbarLink>
            <OpenLinksButton
              onClick={() => {
                setExtendNavbar((curr) => !curr);
              }}
            >
              {extendNavbar ? <>&#10005;</> : <> &#8801;</>}
            </OpenLinksButton>
          </NavbarLinkContainer>
        </LeftContainer>

        <RightContainer>
        <NavbarLink
              href="#"
              onClick={() => setActiveNav("#")}
              className={activeNav === "#" ? "active" : ""}
            >
              {" "}
              Mitresh
            </NavbarLink>
          {/* <Logo >Mitresh</Logo> */}
        </RightContainer>
      </NavbarInnerContainer>
      {extendNavbar && (
        <NavbarExtendedContainer>
          <NavbarLinkExtended
              href="#"
              onClick={() => setActiveNav("#")}
              className={activeNav === "#" ? "active" : ""}
            >
              {" "}
              Home
            </NavbarLinkExtended>
            <NavbarLinkExtended
              href="#gitStats"
              onClick={() => setActiveNav("#gitStats")}
              className={activeNav === "#gitStats" ? "active" : ""}
            >
              {" "}
              Github
            </NavbarLinkExtended>
            <NavbarLinkExtended
              href="#skills"
              onClick={() => setActiveNav("#skills")}
              className={activeNav === "#skills" ? "active" : ""}
            >
              {" "}
              Skills
            </NavbarLinkExtended>
            <NavbarLinkExtended
              href="#portfolio"
              onClick={() => setActiveNav("#portfolio")}
              className={activeNav === "#portfolio" ? "active" : ""}
            >
              {" "}
              Projects
            </NavbarLinkExtended>
            <NavbarLinkExtended
              href="#contact"
              onClick={() => setActiveNav("#contact")}
              className={activeNav === "#contact" ? "active" : ""}
            >
              {" "}
              Contact
            </NavbarLinkExtended>
            <NavbarLinkExtended
              href="#contact"
              
            >
              {" "}
              Resume
            </NavbarLinkExtended>
        </NavbarExtendedContainer>
      )}
    </NavbarContainer>
  );

  // return (
  //   <NAV>
  //     <div>
  //       <a href="#"
  //       onClick={() => setActiveNav("#")}
  //       className={activeNav === "#" ? "active" : ""}><h2>Mitresh</h2></a>
  //       {/* <img src="" alt="" /> */}
  //     </div>
  //     <div><HiMenu onClick={()=> setHam(!ham)}/></div>
  //     <div >
  //       <a href="#"
  //       onClick={() => setActiveNav("#")}
  //       className={activeNav === "#" ? "active" : ""}>About</a>
  //       <a  href="#skills"
  //       onClick={() => setActiveNav("#skills")}
  //       className={activeNav === "#skills" ? "active" : ""}>Skills</a>
  //       <a href="#portfolio"
  //       onClick={() => setActiveNav("#portfolio")}
  //       className={activeNav === "#portfolio" ? "active" : ""}>Projects</a>
  //       <a href="#contact"
  //       onClick={() => setActiveNav("#contact")}
  //       className={activeNav === "#contact" ? "active" : ""}>Contact</a>
  //     </div>
  //   </NAV>
  // );
};

const NavbarContainer = styled.nav`
  width: 100%;
  height: ${(props) => (props.extendNavbar ? "100vh" : "80px")};
  background-color: black;
  z-index: 10;
  position: fixed;
  top: 0;
  display: flex;
  flex-direction: column;
  @media (min-width: 700px) {
    height: 80px;
  }
`;

const LeftContainer = styled.div`
  flex: 70%;
  display: flex;
  align-items: center;
  padding-left: 5%;
`;

const RightContainer = styled.div`
  flex: 30%;
  display: flex;
  justify-content: flex-end;
  padding-right: 50px;
`;

const NavbarInnerContainer = styled.div`
  width: 100%;
  height: 80px;
  display: flex;
`;

const NavbarLinkContainer = styled.div`
  display: flex;
`;

const NavbarLink = styled.a`
  color: white;
  font-size: x-large;
  text-decoration: none;
  margin: 10px;
  @media (max-width: 700px) {
    display: none;
  }
`;

const NavbarLinkExtended = styled.a`
  color: white;
  font-size: x-large;
  text-decoration: none;
  margin: 10px;
`;

const Logo = styled.h1`
color: #ffff;
font-weight: bolder;
  margin: 10px;
  max-width: 180px;
  /* height: auto; */
`;

const OpenLinksButton = styled.button`
  width: 70px;
  height: 50px;
  background: none;
  border: none;
  color: white;
  font-size: 45px;
  cursor: pointer;
  @media (min-width: 700px) {
    display: none;
  }
`;

const NavbarExtendedContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (min-width: 700px) {
    display: none;
  }
`;


// ******Bin******
// const NAV = styled.div`
//   display: flex;
//   width: 100%;
//   justify-content: space-between;
//   padding: 0.5rem 0;
//   position: fixed;
//   z-index: 5;
//   gap: 1rem;
//   background-color: ${COLOR1};

//   div{
//     display: flex;
//     padding: 0 2rem;
//     justify-content: space-evenly;
//     align-items: center;
//     gap: 2rem;
//     a {
//       color: ${WHITE};
//       text-decoration: none;
//     }

//     &:nth-child(2){
//       display: none;
//       font-size: 2rem;
//     }
//     @media screen and (min-width: 300px) and (max-width: 768px){
//       padding: 0 0.25rem;
//       gap: 1rem;

//       &:nth-child(2){
//         display: block;
//         margin: auto 2rem;
//         font-weight: bold;
//         color: white;
//       }
//       &:nth-child(3){
//         display: none;
//         flex-direction: column;

//       }
//      }
//   }

// `;

// @media screen and (min-width: 300px) and (max-width: 768px){
//   div:nth-child(2){
//     display: block;
//     margin: auto 2rem;
//   }
//   div:nth-child(3){
//     display: none;
//   }

//  }
